import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="Concubine x Casual SEX CAMPUS parte 2"
      portada="https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-1.jpg"
  paginas={[
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-1.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-2.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-3.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-4.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-5.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-6.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-7.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-8.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-9.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-10.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-11.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-12.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-13.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-14.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-15.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-16.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-17.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-18.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-19.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-20.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-21.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-22.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-23.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-24.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-25.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-26.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-27.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-28.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-29.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-30.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-31.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-32.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-33.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-34.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-35.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-36.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-37.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-38.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-39.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-40.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-41.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-42.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-43.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-44.jpg",
  "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-45.jpg"
]}
      sugeridos={[]}


      info={{
   grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Armpit Licking", "Big Breasts", "Cheating", "Defloration", "Digital", "Filming", "Fingering", "Freckles", "Kissing", "Multi-work Series", "Netorare", "Nipple Stimulation", "Pixie Cut", "Sole Male", "Sweating", "Swimsuit", "Tanlines", "Tomboy"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "Concubine x Casual SEX CAMPUS parte 2",
  portada: "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-1.jpg",
  reverso: "https://fullcomics18.org/img12/concubine-x-casual-sex-campus2-17.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Armpit Licking", "Big Breasts", "Cheating", "Defloration", "Digital", "Filming", "Fingering", "Freckles", "Kissing", "Multi-work Series", "Netorare", "Nipple Stimulation", "Pixie Cut", "Sole Male", "Sweating", "Swimsuit", "Tanlines", "Tomboy"],
    artistas: "Fuetakishi",
  },
};
